// extracted by mini-css-extract-plugin
module.exports = {"formButtonGroup":"_2o4GD","backdrop":"hMI-b","spinnerContainer":"_3kQbU","spinner":"_3EJWz","rotate":"_3fKMx","path":"PfxZg","dash":"_3a1qN"};